import { Permission } from 'shared'
import { CIMSTabs } from '../../../../../../../components/CIMSTabs'
import Exports from './components/Exports'
import Imports from './components/Imports'

const CSVTab = {
  Imports: 'Imports',
  Exports: 'Exports',
}

function CSV() {
  return (
    <CIMSTabs
      initialTab={CSVTab.Exports}
      tabs={[
        {
          key: CSVTab.Exports,
          label: CSVTab.Exports,
          permission: Permission.ExportCSV,
          component: <Exports />,
        },
        {
          key: CSVTab.Imports,
          label: CSVTab.Imports,
          permission: Permission.ImportCSV,
          // Unmount the component when the route changes (e.g. project changes)
          // to avoid stale data showing in the UI.
          component: <Imports key={window.location.href} />,
        },
      ]}
    />
  )
}

export default CSV
